export default __webpack_public_path__ + "static/media/pastCollectionIcon.6c9daf90.svg";